export const getConfig = () => {
  return window.config;
};
